<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
  </page>
</template>

<script>
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Item 1',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: '' }
        },
        {
          text: 'Item 2',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: '' }
        }
      ]
    }
  },
  components: {
    SideFunctionMenu
  }
}
</script>
